import React from 'react';
import PopupRenderer from '../PopupRenderer';
import type { ColumnsBlockContent } from '../../../types/popup.types';

interface ColumnsBlockProps {
  content: ColumnsBlockContent;
}

const ColumnsBlock: React.FC<ColumnsBlockProps> = ({ content }) => {
  const { columns, gap, divider, dividerColor, dividerWidth } = content;

  if (!columns || columns.length === 0) return null;

  return (
    <div
      style={{
        display: 'flex',
        marginBottom: '16px',
      }}
    >
      {columns.map((column, index) => {
        const isLastColumn = index === columns.length - 1;
        
        return (
          <div
            key={index}
            style={{
              width: `${column.width}%`,
              minHeight: '60px',
              backgroundColor: column.backgroundColor || 'transparent',
              border: `${column.borderWidth || 0}px solid ${column.borderColor || 'transparent'}`,
              borderRadius: `${column.borderRadius || 8}px`,
              padding: `${column.padding || 16}px`,
              textAlign: (column.align || 'left') as 'left' | 'center' | 'right',
              marginRight: isLastColumn ? 0 : `${gap || 16}px`,
              borderRight:
                divider && !isLastColumn
                  ? `${dividerWidth || 1}px solid ${dividerColor || '#e0e0e0'}`
                  : undefined,
            }}
          >
            <PopupRenderer blocks={column.blocks || []} />
          </div>
        );
      })}
    </div>
  );
};

export default ColumnsBlock;
